module.exports = __webpack_public_path__ + "img/no_data.8fd043da.png";